import Analytics from 'analytics'
import cdpDumpPlugin from './cdpDumpPlugin'
import { isCategoryConsented } from './cookieHelpers'

let analytics = null

function initAnalytics() {
  analytics = Analytics({
    app: 'plickers-web-students',
    plugins: [
      cdpDumpPlugin({
        appName: 'plickers-web-students',
        writeKey: process.env.REACT_APP_CDPDUMP_WRITE_KEY,
        host: process.env.REACT_APP_CDPDUMP_HOST,
        endpointPrefix: '/cdp/v1',
        // enableDebugLogging: true, // enable this to get more logs into browser console
      }),
    ],
  })
}

function getAnalyticsInstance() {
  if (!analytics) initAnalytics()
  return analytics
}

function isAnalyticsConsented() {
  return isCategoryConsented('analytics')
}

function track(eventName, properties = {}) {
  if (isAnalyticsConsented()) {
    const analytics = getAnalyticsInstance()
    analytics.track(eventName, properties)
  }
}

function page(pageName, properties = {}) {
  if (isAnalyticsConsented()) {
    const analytics = getAnalyticsInstance()
    analytics.page({
      name: pageName,
      ...properties,
    })
  }
}

export default {
  initAnalytics,
  track,
  page,
}
